import { css } from '@emotion/react';
import styled from '@emotion/styled';
import facepaint from 'facepaint';

import { ClockLoader } from 'react-spinners';

const typography = css`
`;

const Typography = styled.div`
  ${typography}
`;

const Page = styled.div`
  ${typography}
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  padding-bottom: 30px;
`;

const Inset = styled.div`
  padding-left: 1rem;
  padding-right: 1rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

const Centered = styled.div`
  padding-left: 1rem;
  padding-right: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

/* color palette */
const DarkGreen = '#5c7a00';
const MediumGreen = '#94ac5c';
const LightGreen = '#dde2b7';
const Gold = '#f5c24f';
const Copper = '#cc6629';
const Black = '#000000';
const DarkGray = '#58595b';
const MediumGray = '#939598';
const LightGray = '#bcbec0';
const OffWhite = '#e6e7e8';
const White = '#ffffff';
const Red = '#cc6629';

const Loading = ({ children }) => (
  <div
    css={{
      alignItems: 'center',
      color: MediumGray,
      display: 'flex',
      flexDirection: 'column',
      fontFamily: 'Open Sans',
      fontSize: 'small',
    }}
  >
    {children} ...
    <div
      css={{
        border: `2px solid ${LightGreen}`,
        borderRadius: '50%',
        height: '30px',
        marginTop: '0.5rem',
        width: '30px',
      }}
    >
      <ClockLoader color={LightGreen} size={30} />
    </div>
  </div>
);

const Name = styled.h3`
  color: ${MediumGreen};
  font-family: Aleo;
  font-size: 1.0em;
`;

// small, medium, large, xlarge
const mq = facepaint([576, 768, 992, 1200].map((bp) => `@media (min-width: ${bp}px)`));

// Useful Tailwind class combinations (these could maybe grow up to be components someday,
// or use a styled-component pattern? for future thinking!)
const reportButtonClasses = [
  'inline-flex',
  'items-center',
  'px-2.5',
  'py-1.5',
  'border',
  'border-gray-300',
  'shadow-sm',
  'text-sm',
  'rounded',
  'bg-white',
  'focus:outline-none',
  'focus:ring-2',
  'focus:ring-offset-2',
  'focus:ring-indigo-500',
];

export {
  reportButtonClasses,
  Black,
  Centered,
  Copper,
  DarkGray,
  DarkGreen,
  Gold,
  Inset,
  LightGray,
  LightGreen,
  Loading,
  MediumGray,
  MediumGreen,
  mq,
  Name,
  OffWhite,
  Page,
  Red,
  typography,
  Typography,
  White,
};
